import React from 'react';
import Form from 'react-bootstrap/Form';
import FormHelpTooltip from '@/components/utils/FormHelpTooltip';
import i18n from 'i18n';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';

type Props = {
    formik: FormikProps<EvaluationTask>;
};

const EvaluationTaskCallsPriceFormFields: React.FC<Props> = React.memo(({formik}) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="params.pricePerMinute" >
                <Form.Label>
                    {i18n.t('jt_price_per.text')}
                    <FormHelpTooltip>
                        {i18n.t('jt_price_per.text')}
                    </FormHelpTooltip>
                </Form.Label>
                <Form.Control
                    type="number"
                    name="params.pricePerMinute"
                    required
                    min={0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.params.pricePerMinute ?? 0}
                    isInvalid={(
                        formik.touched.params?.pricePerMinute &&
                        !!formik.errors.params?.pricePerMinute
                    ) || (formik.values.params.pricePerMinute ?? 0) < 0}
                />
                <Form.Control.Feedback
                    type="invalid"
                    style={{
                        display:
                            formik.touched.params?.pricePerMinute &&
                                formik.errors.params?.pricePerMinute
                                ? 'block'
                                : 'none',
                    }}
                >
                    {formik.errors.params?.pricePerMinute}
                </Form.Control.Feedback>
            </Form.Group >
        </>
    );
});

export default EvaluationTaskCallsPriceFormFields; 